import { SimpleError } from "@simonbackx/simple-errors";
import { PatchableArray, PatchableArrayDecoder } from "./PatchableArray";
import StringOrNumberDecoder from "./StringOrNumberDecoder";
export class ArrayDecoder {
    constructor(decoder) {
        this.decoder = decoder;
    }
    decode(data) {
        if (Array.isArray(data.value)) {
            return data.value
                .map((v, index) => {
                return data.clone({
                    data: v,
                    context: data.context,
                    field: data.addToCurrentField(index)
                }).decode(this.decoder);
            });
        }
        throw new SimpleError({
            code: "invalid_field",
            message: `Expected an array at ${data.currentField}`,
            field: data.currentField,
        });
    }
    patchType() {
        const elementDecoder = this.decoder;
        if (elementDecoder.patchType) {
            const patchDecoder = elementDecoder.patchType();
            // Check if we have a method called "getIdentifier"
            let idFieldType;
            if (elementDecoder.patchIdentifier) {
                // Custom identifier (in case no automatic detection is possible)
                idFieldType = elementDecoder.patchIdentifier();
            }
            else {
                if (patchDecoder.prototype.getIdentifier) {
                    // This autoencoder uses the getIdentifier method to define the id
                    idFieldType = StringOrNumberDecoder;
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    const field = elementDecoder.fields.find((field) => field.property == "id");
                    if (field) {
                        idFieldType = field.decoder;
                    }
                }
            }
            if (idFieldType) {
                return new PatchableArrayDecoder(elementDecoder, patchDecoder, idFieldType);
            }
            else {
                // A non identifiable array -> we expect an optional array instead = default behaviour
                // upgrade / downgrade kan stay the same as default
                // We expect a normal array, of same type
                return this;
            }
        }
        // Upgrade / downgrades cannot work when pathcing, should be placed on instances
        //field.upgrade = this.upgradePatch
        //field.downgrade = this.downgradePatch
        return new PatchableArrayDecoder(elementDecoder, elementDecoder, elementDecoder);
    }
    /**
     * Patchable values of an array always create a default empty patchable array for convenience
     */
    patchDefaultValue() {
        const elementDecoder = this.decoder;
        if (elementDecoder.patchType) {
            const patchDecoder = elementDecoder.patchType();
            // Check if we have a method called "getIdentifier"
            let idFieldType;
            if (elementDecoder.patchIdentifier) {
                // Custom identifier (in case no automatic detection is possible)
                idFieldType = elementDecoder.patchIdentifier();
            }
            else {
                if (patchDecoder.prototype.getIdentifier) {
                    // This autoencoder uses the getIdentifier method to define the id
                    idFieldType = StringOrNumberDecoder;
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    const field = elementDecoder.fields.find((field) => field.property == "id");
                    if (field) {
                        idFieldType = field.decoder;
                    }
                }
            }
            if (idFieldType) {
                return new PatchableArray();
            }
            else {
                // A non identifiable array -> we expect an optional array instead = default behaviour
                // upgrade / downgrade kan stay the same as default
                // We expect a normal array, of same type
                return undefined;
            }
        }
        return new PatchableArray();
    }
}
//# sourceMappingURL=ArrayDecoder.js.map